
import { Component, Vue } from "vue-property-decorator"
import { State, Action, Mutation, Getter } from "vuex-class"
import { BaseState } from "@/store"
import { CurrentUser, UserPreferences } from "@/types/user"
import Label from "@/components/Dashboard/Label.vue"
import { TenantFeatures } from "@/types/tenantFeatures"

@Component({
	components: { Label }
})
export default class NewInterfaceSwitch extends Vue {
	@State((state: BaseState) => state.me)
	me!: CurrentUser

	@State((state: BaseState) => state.me?.preferences)
	userPreferences: UserPreferences | undefined

	@Action("updateUserPreferences")
	updatePreferences!: (prefs: UserPreferences) => Promise<void>

	@Mutation("setInterfaceLoading")
	setInterfaceLoading!: (loading: boolean) => void

	@Getter getUseV2!: boolean

	get useV2 () {
		return this.getUseV2
	}

	set useV2 (value: boolean) {
		let newPreferences: UserPreferences = (!this.userPreferences) ? { disableV2: false, enableV2: false } : { ...this.userPreferences }

		newPreferences.disableV2 = !value

		if (this.me.tenantEnabledFeatures?.includes(TenantFeatures.NewUIOptIn)) {
			newPreferences.enableV2 = value
		}

		this.setInterfaceLoading(true)

		this.updatePreferences(newPreferences).then(() =>
			// Reload to go to correct new/old pages
			this.$router.go(0)
		)
	}
}
